<template>
  <div>
    <van-row class="title" style="background: #f2f2f2; padding: 10px">
      <van-col span="12">
        <span>我的订单</span>
      </van-col>
    </van-row>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        style="margin-top: 39px"
      >
        <van-row
          v-for="item in orderList"
          :key="item.id"
          style="margin-top: 10px"
          @click="toDetails(item)"
        >
          <van-row style="width: 100%; padding: 5px 20px">
            <van-col span="12">
              <span>
                {{ $moment(item.reserveDate).format("YYYY-MM-DD") }}
                {{ item.reserveMealName }}
              </span>
            </van-col>
            <van-col style="color: #aaaaaa" span="12" align="right">
              <span>{{ item.statusName }}</span>
            </van-col>
          </van-row>
          <van-row style="width: 100%; padding: 5px 20px">
            <van-col span="12">
              <span> {{ item.businessCateringOrderDetailses.length }}道菜</span>
            </van-col>
            <van-col span="12" align="right">
              <span>￥{{ item.businessPayOrder.price }}</span>
            </van-col>
          </van-row>
          <van-row
            style="
              width: 100%;
              padding: 5px 20px;
              border-bottom: 1px solid #ccc;
            "
          >
            <van-col span="12">
              <p
                style="
                  width: 200px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  -o-text-overflow: ellipsis;
                  color: #aaaaaa;
                "
              >
                {{ item.dishNames }}
              </p>
            </van-col>
            <van-col span="12" align="right">
              <span style="color: #aaaaaa">
                {{ $moment(item.createTime).format("YYYY-MM-DD HH:mm:ss") }}
              </span>
            </van-col>
          </van-row>
        </van-row>
      </van-list>
    </van-pull-refresh>
    <div class="back-home" @click="backHome">
      <p>回首页</p>
    </div>
  </div>
</template>
<script setup>
import { orderPage } from "@/api/orderingFood/orderingFood";
import { reactive, toRefs, ref } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
const state = reactive({
  searchData: {
    pageNum: 1,
    pageSize: 10,
  },
  orderList: [],
});
const { orderList } = toRefs(state);
const loading = ref(false);
const finished = ref(false);
const refreshing = ref(false);
// const queryOrderList = () => {
//   orderPage(state.searchData).then((v) => {
//     const { data } = v;
//     state.orderList = data.records;
//   });
// };
// queryOrderList();
// 返回首页
const backHome = () => {
  router.go(-1);
};
// 上拉加载
const onLoad = () => {
  orderPage(state.searchData).then((v) => {
    if (refreshing.value) {
      state.orderList = [];
      refreshing.value = false;
    }
    const { data } = v;
    state.orderList.push(...data.records);
    if (data.records.length > 0) {
      state.searchData.pageNum++;
      loading.value = false;
    } else {
      finished.value = true;
    }
  });
};
// 跳转详情
const toDetails = (item) => {
  router.push({ name: "mealsOrderDetails", query: { id: item.id } });
};
// 下拉刷新
const onRefresh = () => {
  state.searchData.pageNum = 1;
  // 清空列表数据
  finished.value = false;
  loading.value = true;
  onLoad();
};
</script>
<style lang="scss" scoped>
.title {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
}
.back-home {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 1px solid #999;
  background: #fff;
  position: fixed;
  bottom: 20px;
  right: 10px;
  z-index: 1;
  p {
    position: absolute;
    width: 100%;
    text-align: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #999;
  }
}
</style>
